<form [formGroup]="formGroup" style="max-width: 600px">
  <app-row>
    <app-input
      label="MGRS"
      i18n-label="@@sre.details.mgrs"
      formControlName="mgrs"
      [required]="true"
      [touched]="formGroup.get('mgrs')?.touched"
      [errorMessage]="formGroup.get('mgrs')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Depth (cm)"
      i18n-label="@@sre.details.depthCm"
      formControlName="depthCm"
      [touched]="formGroup.get('depthCm')?.touched"
      [errorMessage]="formGroup.get('depthCm')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Parcel #"
      i18n-label="@@sre.details.parcelNumber"
      formControlName="parcelNumber"
      [touched]="formGroup.get('parcelNumber')?.touched"
      [errorMessage]="formGroup.get('parcelNumber')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Lane #"
      i18n-label="@@sre.details.laneNumber"
      formControlName="laneNumber"
      [touched]="formGroup.get('laneNumber')?.touched"
      [errorMessage]="formGroup.get('laneNumber')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Distance (m)"
      i18n-label="@@sre.details.distanceMeters"
      formControlName="distance"
      [touched]="formGroup.get('distance')?.touched"
      [errorMessage]="formGroup.get('distance')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Name of Reporter"
      i18n-label="@@sre.details.reporterName"
      formControlName="pocName">
    </app-input>
  </app-row>

  <app-row>
    <app-input
      label="Title of Reporter"
      i18n-label="@@sre.details.reporterTitle"
      formControlName="reporterTitle"
      [touched]="formGroup.get('reporterTitle')?.touched"
      [errorMessage]="formGroup.get('reporterTitle')?.errors">
    </app-input>
  </app-row>

  <app-row>
    <app-input-datetime
      label="Date"
      i18n-label="@@sre.details.date"
      formControlName="firstNoticedDate">
    </app-input-datetime>
  </app-row>

  <app-row>
    <app-input
      label="Additional comments"
      i18n-label="@@sre.details.additionalComments"
      type="textarea"
      formControlName="additionalComments"
      [touched]="formGroup.get('additionalComments')?.touched"
      [errorMessage]="formGroup.get('additionalComments')?.errors">
    </app-input>
  </app-row>
</form>
